import React, { Fragment, useEffect } from "react";

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  makeStyles,
} from "@material-ui/core";
import { orderBy } from "lodash";

import { FormHeader } from "@hubcapp/components";
import Button from "@ds-developer/button";

import { RandomSignInFormProps } from "./types";

const useStyles = makeStyles(theme => ({
  submitButton: {
    marginTop: theme.spacing(4),
    minWidth: "100px",
    minHeight: "42px",
  },
  tabs: {
    marginBottom: "1rem",
  },
}));

const RandomSignInForm: React.FC<RandomSignInFormProps> = ({
  onSubmit,
  onChange,
  isValid,
  loading,
  register,
  value = "",
  instructors = [],
  selectedTab = "dropdown",
  onSelectedTabChange = () => {},
  ...rest
}) => {
  const classes = useStyles();

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <>
      <form {...rest} onSubmit={onSubmit}>
        <FormHeader
          testId="sign-in-form-header"
          title="Sign in"
          subtitle={"Sign in to Hubcapp, the instructor portal."}
        />

        <Tabs
          value={selectedTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, value) => {
            onSelectedTabChange(value);
          }}
          aria-label="Account tabs"
          className={classes.tabs}
          variant="fullWidth"
        >
          <Tab key={"dropdown"} label={"Random selection"} value={"dropdown"} />
          <Tab key={"input"} label={"Use ADI Number"} value={"input"} />
        </Tabs>

        <FormControl fullWidth>
          {selectedTab === "dropdown" && (
            <Fragment>
              <InputLabel>Select Instructor</InputLabel>
              <Select
                name="instructor"
                id="instructor"
                disabled={loading}
                value={value}
                inputRef={register}
                // @ts-ignore Select enforces a value of 'unknown',
                // when we know it's a string
                onChange={(e: any) =>
                  onChange &&
                  onChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: "Select",
                    },
                  })
                }
              >
                {orderBy(instructors, "name.lastName").map(instructor => (
                  <MenuItem key={instructor.id} value={instructor.id}>
                    {instructor.name.firstName} {instructor.name.lastName}
                    {" ("}
                    {instructor?.description}
                    {")"}
                  </MenuItem>
                ))}
              </Select>
            </Fragment>
          )}
          {selectedTab === "input" && (
            <Fragment>
              <TextField
                fullWidth
                inputProps={{
                  inputMode: "decimal",
                }}
                inputRef={register}
                label="Instructor ADI Number"
                name="adiNumber"
                type="text"
                variant="outlined"
                onInput={(e: any) =>
                  onChange &&
                  onChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: "Input",
                    },
                  })
                }
              />
            </Fragment>
          )}
        </FormControl>

        <Button
          className={classes.submitButton}
          disabled={!isValid || loading}
          size="large"
          type="submit"
          variant="contained"
          color="primary"
          loading={loading}
        >
          Sign in
        </Button>
      </form>
    </>
  );
};

export default RandomSignInForm;
